import type {
  IUserNotificationType,
  IUserNotificationSchema,
} from '~/@api/generated-api-types-user/Api'

import { MailIcon } from 'lucide-react'
import { cn } from '~/shadcn/lib/utils'
import { CheckCircleIcon } from '~/@mid_ui/icons/CheckCircleIcon'
import { WarningIcon } from '~/@mid_ui/icons/WarningIcon'
import { ErrorIcon } from '~/@mid_ui/icons/ErrorIcon'
import { InvestorFeeIcon } from '../icons/InvestorFeeIcon'

export type NotificationType =
  | IUserNotificationType.RegistrationFinished
  | IUserNotificationType.WithdrawalSuccess
  | IUserNotificationType.OrderCreated
  | IUserNotificationType.AdminCompanyConfirmation
  | IUserNotificationType.FeeNotice
  | 'emailVerification'
type Props = {
  type?: NotificationType
  category: IUserNotificationSchema['category']
}

function NotificationBannerIcon({ type, category }: Props) {
  if (type === 'emailVerification') {
    return <MailIcon className={cn('self-baseline w-6 h-6')} />
  }
  if (type === 'fee_notice') {
    return <InvestorFeeIcon className={cn('w-6 h-6 self-baseline')} />
  }

  if (category === 'success') {
    return (
      <CheckCircleIcon
        fillColor="#121212"
        strokeColor="#FFFFFF"
        className={cn('self-baseline')}
      />
    )
  }

  if (category === 'warning') {
    return (
      <WarningIcon className={cn('self-baseline w-6 h-6 text-[#121212]')} />
    )
  }

  if (category === 'error') {
    return <ErrorIcon className={cn('self-baseline')} />
  }

  return null
}

export { NotificationBannerIcon }
